// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';
import { AdminType } from './admin-type';
import { Bond } from './bond';
import { RateValue } from './rate-value';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class Bonding extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  
  /// </code>

  // Generated code. Do not place code below this line.
  bondingId!: number;
  adminTypeId?: number;
  assetAsAtDate?: Date;
  assetValue!: number;
  bondId!: number;
  createdBy!: string;
  createdDate!: Date;
  entryDate!: Date;
  entryTypeId!: number;
  fromAdminTypeId?: number;
  memo?: string;
  premium!: number;
  rateValueId!: number;
  releaseDate?: Date;
  reportingDate?: Date;
  specificPenalty!: number;
  submittedDate?: Date;
  ts!: string;
  updatedBy!: string;
  updatedDate!: Date;
  adminType!: AdminType;
  bond!: Bond;
  fromAdminType!: AdminType;
  rateValue!: RateValue;
}

